import { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Button from 'ui/Button';
import Dialog from 'ui/Dialog';
import Icon from 'ui/Icon';

import { useTemplateSankeysWithSVGQuery } from '../../../api';
import { pathToSankey } from '../../../utils/routes';
import TemplateDiagramsView from '../../TemplateDiagramsView';

type Props = {
  open: boolean;
  setOpen: (open: boolean) => void;
};

// TODO: Rename to BrowseTemplatesDialog
const BrowseTemplatesModal: React.FC<Props> = ({ open, setOpen }) => {
  const navigate = useNavigate();
  const [selectedDiagramId, setSelectedDiagramId] = useState<number>();

  // Fetch all templates
  const query = useTemplateSankeysWithSVGQuery(open);
  const templateSankeys = useMemo(() => query.data ?? [], [query.data]);

  // Open selected template in the editor
  const openTemplate = useCallback(() => {
    if (selectedDiagramId) {
      navigate(pathToSankey(selectedDiagramId));
      setOpen(false);
    }
  }, [selectedDiagramId]);

  // Reset selected diagram when modal is closed
  useEffect(() => {
    if (!open) {
      setSelectedDiagramId(undefined);
    }
  }, [open]);

  return (
    <Dialog.Root open={open} onOpenChange={(e) => setOpen(e.open)} size="cover">
      <Dialog.Content>
        <form onSubmit={openTemplate}>
          <Dialog.Header>
            <Icon fontSize="md" icon="file-regular" mr={2} /> Choose a template
          </Dialog.Header>
          <Dialog.Body>
            <TemplateDiagramsView
              isLoading={query.isLoading}
              templateSankeys={templateSankeys}
              selectedDiagramId={selectedDiagramId}
              onClick={(id) => setSelectedDiagramId(id)}
              onDoubleClick={openTemplate}
            />
          </Dialog.Body>
          <Dialog.Footer>
            <Button
              type="submit"
              variant="primary-solid"
              disabled={!selectedDiagramId}
              title={
                !selectedDiagramId
                  ? 'Please select a template to open'
                  : undefined
              }
            >
              Open template
            </Button>
          </Dialog.Footer>
        </form>
      </Dialog.Content>
    </Dialog.Root>
  );
};

export default BrowseTemplatesModal;
